import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, options, references } from '@apexdesigner/schema-tools';

export const student = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    firstName: z.string().nullable().optional().describe('First Name'),

    lastName: z.string().nullable().optional().describe('Last Name'),

    email: z.string().nullable().optional().describe('Email'),

    dateOfBirth: z
      .string()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('Date Of Birth'),

    currentGradeLevel: options([
      { value: 'Kindergarten', name: 'Kindergarten' },
      { value: '1', name: '1' },
      { value: '2', name: '2' },
      { value: '3', name: '3' },
      { value: '4', name: '4' },
      { value: '5', name: '5' },
      { value: '6', name: '6' },
      { value: '7', name: '7' },
      { value: '8', name: '8' },
      { value: '9', name: '9' },
      { value: '10', name: '10' },
      { value: '11', name: '11' },
      { value: '12', name: '12' },
      { value: 'Adult', name: 'Adult' },
    ])
      .nullable()
      .optional()
      .describe('Current Grade Level'),

    created: z.coerce.date().nullable().optional().hidden().describe('Created'),

    organizationId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Organization'),

    appUserId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    organization: references('Organization'),

    appUser: references('User'),

    prescriptions: hasMany('Prescription'),

    testResults: hasMany('TestResult'),

    selectedStudents: hasMany('SelectedStudent'),

    alternateStudents: hasMany('AlternateStudent'),

    attendances: hasMany('Attendance'),

    sessionHistories: hasMany('SessionHistory'),
  })
  .describe(
    'A learner enrolled at an organization and tutored under a curriculum prescription.',
  )
  .as('Student');

export { student as studentSchema };
